/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/${metaData}`, payload)
      .then((response) => response.data.queryResult)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/${metaData}`, payload)
      .then((response) => response.data.queryResult)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadPackagesDetails(destinations) {
  // const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(
      `/package/get-all-data${destinations !== undefined ? destinations : ""}`
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadDestinationSearchDetails(destinations) {
  // const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(
      `/package/top-search-drop-down-data${destinations !== undefined ? destinations : ""}`
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPackagesTotalDetails(destinations) {
  // const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(
      `/package/get-all-data${destinations !== undefined ? destinations : ""}`
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPackageSingleDetails(destinations) {
  // const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(`/package/get-one/${destinations}`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadTermsConditionsDetails() {
  return await api
    .get(`/termAndCondition/get-all-data`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadTermsConditionsSingleDetails(destinations) {
  // const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(`/termAndCondition/get-one/${destinations}`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPackagesFaqMainDetails(destinations) {
  return await api
    .get(`/faq/get-all-data${destinations ? destinations : ""}`)
    .then((response) => response.data.queryResult)
    .catch((error) => Promise.reject(error));
}
export async function loadPackagesFaqDetails(destinations) {
  // const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(`/faq/get-one/${destinations ? destinations : ""}`)
    .then((response) => response.data.queryResult)
    .catch((error) => Promise.reject(error));
}
export async function loadTravellerAgeRestrictionsDetails(destinations) {
  // const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(
      `/package/traveller-age-restriction${destinations ? destinations : ""}`
    )
    .then((response) => response.data.datum)
    .catch((error) => Promise.reject(error));
}

const remotes = {
  loadTermsConditionsDetails,
  loadDestinationSearchDetails,
  loadTermsConditionsSingleDetails,
  loadTravellerAgeRestrictionsDetails,
  loadPackagesDetails,
  loadPackageSingleDetails,
  loadPackagesFaqMainDetails,
  loadPackagesFaqDetails,
  loadRecordsMetaData,
  loadPackagesTotalDetails,
};

export default remotes;
